<template>
  <div class="state-buttons">
    <div
      v-for="state in states"
      :key="state.value"
      :class="buttonClasses(state)"
      :style="buttonStyles(state)"
      @click.stop="handleButtonClick(state)"
    >
      <font-awesome-icon :icon="state.icon" class="icon" />
      <span class="text">{{ state.title }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "StateButtons",

  props: {
    value: {
      type: String,
      default: ""
    },
    onlyActiveState: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      states: [
        {
          value: "0",
          title: "erledigt",
          icon: "check-circle",
          color: "#00AB6A"
        },
        {
          value: "1",
          title: "to do",
          icon: "plus-circle",
          color: "#EF7845"
        },
        {
          value: "2",
          title: "nicht möglich",
          icon: "minus-circle",
          color: "#212121"
        }
      ]
    };
  },

  methods: {
    buttonClasses(state) {
      return {
        button: true,
        active: this.value === state.value,
        empty: !this.value,
        hide: this.onlyActiveState && this.value !== state.value,
        single: this.onlyActiveState && this.value === state.value,
        disabled: this.onlyActiveState
      };
    },
    buttonStyles(state) {
      return {
        backgroundColor:
          this.value === state.value ? state.color : "transparent"
      };
    },
    handleButtonClick(state) {
      this.$emit("change", state);
    }
  }
};
</script>

<style scoped lang="scss">
.state-buttons {
  display: flex;
  border: 1px solid #f6f6f6;
  border-radius: 6px;
  margin-right: 15px;
  margin-bottom: auto;
  width: 100%;
}

.button {
  border-right: 1px solid #f6f6f6;
  flex: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 10px;
  white-space: nowrap;
  transition: all 0.2s linear;
  cursor: pointer;
  width: auto;

  &:first-child {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }

  &:last-child {
    border-right: none;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }

  &.active {
    flex: 1;

    .text {
      // font-weight: bold;
      display: inline-block;
    }
  }

  &.empty {
    flex: 1;
  }

  &.hide {
    display: none;
  }

  &.single {
    border-radius: 6px;

    .icon {
      display: none;
    }
  }

  &.disabled {
    cursor: default;
  }

  .icon {
    margin-right: 5px;
  }

  .text {
    display: none;
    font-size: 0.8rem;
  }
}

@media (min-width: 320px) {
  .button {
    flex: 1;

    .text {
      display: inline-block;
    }
  }
}

@media (min-width: 900px) {
  .state-buttons {
    max-width: 300px;
  }
}
</style>
